import React from 'react';
import { lowerFirst, startCase } from 'lodash';
import { gql, graphql } from 'react-apollo';
import Form from './Form';
import jsonSchemaToGqlQuery from '../GqlCmsConfigLib/jsonSchemaToGqlQuery';
import getCRUDSchemaFromResource from '../GqlCmsConfigLib/getCRUDSchemaFromResource';
import removeTypename from '../removeTypename';
import graphqlWithoutCache from '../graphqlWithoutCache';
import undefinedToNull from '../formLib/undefinedToNull';
import joinFieldArraysIntoOne from '../formLib/joinFieldArraysIntoOne';
import alertFirstGqlMsg from '../alertFirstGqlMsg';
import { toast } from '../App';

function ReadOne(props) {
  const { config, resource, data, history, createFromTemplate } = props;
  const purifiedFormData = removeTypename(data[resource.crudMapping.readOne]);
  if (data.loading) {
    return null;
  }

  const resourceName = resource.displayName || resource.name;

  const onCancel = () => {
    history.push(`/${resourceName}`);
  };
  const readOneSchema = getCRUDSchemaFromResource({
    config,
    resource,
    crudType: 'readOne',
  });
  const uiSchema = {
    'ui:disabled': true,
    ...readOneSchema.uiSchema,
  };

  const extraProps = {};

  if (resource.crudMapping.useTemplate) {
    const onUseTemplate = async () => {
      let input = undefinedToNull(purifiedFormData);
      input = joinFieldArraysIntoOne(input, readOneSchema.jsonSchema);
      try {
        const newObject = await createFromTemplate({ variables: { input } });
        history.push(`/${resourceName === 'Encouragement' ? resourceName : resource.name.replace('template', '')}/${newObject.data[resource.crudMapping.useTemplate]}/edit`);
        toast.success('Template successfully copied to your library');
        return input;
      } catch (err) {
        alertFirstGqlMsg(err);
      }
    };

    extraProps.onUseTemplate = onUseTemplate;
  }

  return (
    <div>
      {
        resource.isTemplate &&
          <h3>
            {
              `Template Library: ${startCase(resourceName).replace('Template ', '')}`
            }
          </h3>
      }
      <Form
        jsonSchemaFormExtensions={config.jsonSchemaFormExtensions}
        schema={readOneSchema.jsonSchema}
        uiSchema={uiSchema}
        formData={purifiedFormData}
        onCancel={onCancel}
        noHtml5Validate
        readOnly
        {...extraProps}
      />
    </div>
  );
}

function ReadOneWithData(props) {
  const { config, resource } = props;
  const { crudMapping, uniqKey } = resource;
  const readOneSchema = getCRUDSchemaFromResource({
    config,
    resource,
    crudType: 'readOne',
  });

  let Component = ReadOne;
  const fieldsQuery = jsonSchemaToGqlQuery(readOneSchema.jsonSchema);
  const ReadOneQuery = gql`
    query ${crudMapping.readOne}($${uniqKey}: String!) {
      ${crudMapping.readOne}(${uniqKey}: $${uniqKey}) ${fieldsQuery}
    }
  `;
  const uniqKeyValue = props.match.params[uniqKey];
  Component = graphqlWithoutCache(
    ReadOneQuery,
    { options: { variables: { [uniqKey]: uniqKeyValue } } })(Component);

  if (crudMapping.useTemplate) {
    const CreateFromTemplate = gql`
      mutation ${crudMapping.useTemplate}($input: ${resource.name.replace('template', '')}Input!) {
        ${crudMapping.useTemplate}(${lowerFirst(resource.name.replace('template', ''))}: $input)
      }
    `;
    Component = graphql(CreateFromTemplate, { name: 'createFromTemplate' })(Component);
  }

  return <Component {...props} />;
}

export default ReadOneWithData;



// WEBPACK FOOTER //
// ./src/byob-cms/src/AppLib/ReadOne.js